<span class="finplan-input">
  <lib-answer *ngFor="let ans of answers" [answer]="ans">
  </lib-answer>
</span>
